import axios from 'axios'
import firebase from 'firebase'
import config from '../config'

const ApiHelper = {
  methods: {
    async apiRequest (uri, params = {}) {
      const token = await firebase.auth()
        .currentUser
        .getIdToken()

      return axios({
        method: 'get',
        url: `${config.api.url}/${uri}`,
        headers: {
          'X-Auth-Platform': 'FS',
          'Authorization': `Bearer ${token}`
        },
        ...params
      })
      .catch((err) => {
        if (err.response.data && err.response.data.message) {
          throw new Error(err.response.data.message)
        }
        throw err
      })
    }
  }
}

export default ApiHelper
